import { FetchStatusInterface } from "@lib/types";
import { Accessor } from "solid-js";

interface Props {
  fetchStatus: Accessor<FetchStatusInterface>;
  class?: string;
}

export function FetchStatusMessage(props: Props) {
  return (
    <p
      class={"my-1 " + (props.class ?? "")}
      classList={{
        "mm-error-message": props.fetchStatus().isError,
        "mm-success-message": props.fetchStatus().isSuccess,
      }}
    >
      {props.fetchStatus().message}
    </p>
  );
}
